// Géocodage en cascade : Nominatim → api-adresse (FR gov) → Photon (Komoot)
// Retourne { latitude, longitude } ou lance une erreur si aucune source ne trouve l'adresse.
export async function geocodeAddress(address) {
  // 1. Nominatim (OpenStreetMap)
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(address)}&format=json&limit=1`,
      { headers: { 'Accept-Language': 'fr' } }
    );
    const data = await res.json();
    if (data?.[0]?.lat) return { latitude: parseFloat(data[0].lat), longitude: parseFloat(data[0].lon) };
  } catch {}

  // 2. API Adresse (gouvernement français) — meilleure couverture des adresses FR.
  // Elle ne connaît QUE la France et répond toujours quelque chose : une adresse
  // belge ou canadienne y devenait une rue de Nîmes. On ne garde donc sa réponse
  // que si elle est sûre d'elle (score de 0 à 1) — une adresse étrangère ou
  // approximative tombe alors sur Photon, qui couvre le monde entier.
  try {
    const res = await fetch(
      `https://api-adresse.data.gouv.fr/search/?q=${encodeURIComponent(address)}&limit=1`
    );
    const data = await res.json();
    const feature = data?.features?.[0];
    const c = feature?.geometry?.coordinates;
    if (c && (feature.properties?.score ?? 0) >= 0.6) return { latitude: c[1], longitude: c[0] };
  } catch {}

  // 3. Photon (Komoot) — fallback mondial
  try {
    const res = await fetch(
      `https://photon.komoot.io/api/?q=${encodeURIComponent(address)}&limit=1`
    );
    const data = await res.json();
    const c = data?.features?.[0]?.geometry?.coordinates;
    if (c) return { latitude: c[1], longitude: c[0] };
  } catch {}

  throw new Error('Adresse introuvable. Précisez la ville ou le pays.');
}
